import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anon) {
  console.error('[supabase] missing env vars VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY')
}

const SUPABASE_FETCH_TIMEOUT_MS = 12000

async function fetchWithTimeout(input, init = {}) {
  if (typeof AbortController === 'undefined' || init.signal) {
    return fetch(input, init)
  }
  const controller = new AbortController()
  const timeout = window.setTimeout(() => controller.abort(), SUPABASE_FETCH_TIMEOUT_MS)
  try {
    return await fetch(input, { ...init, signal: controller.signal })
  } finally {
    window.clearTimeout(timeout)
  }
}

export const supabase = createClient(url, anon, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
  global: { fetch: fetchWithTimeout },
})
